import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { NzDatePickerModule, NzRangePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';

@Component({
  selector: 'korviu-range-picker',
  templateUrl: './korviu-range-picker.component.html',
  styleUrls: ['./korviu-range-picker.component.scss'],
  imports: [NzDatePickerModule, NzFormModule, ReactiveFormsModule],
  standalone: true
})
export class KorviuRangePickerComponent {
  @Input() showTime: boolean = false;
  @Input() control: AbstractControl;
  @Input() disabledDate: (currentDate: Date) => boolean;

  public formatDate: string = 'd MMM yyyy';

  constructor() {}
  public get formControl(): FormControl {
    return this.control as FormControl;
  }

  public get hasValue(): boolean {
    return typeof this.formControl?.value === 'number' || this.formControl?.value;
  }

  public isFieldFocusing: boolean;
}
